import React, { useState, useEffect } from 'react';
import * as signalR from '@microsoft/signalr';

// API URL from environment variable only
const API_URL = process.env.REACT_APP_API_URL;

const TestSignalR = () => {
    const [messages, setMessages] = useState([]);
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        // Create SignalR connection
        // Remove '/api' from API_URL to get base URL for SignalR
        const baseUrl = API_URL ? API_URL.replace('/api', '') : '';
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${baseUrl}/reportHub`)
            .withAutomaticReconnect()
            .build();

        // Set up message handler
        newConnection.on('ReceiveMessage', (message) => {
            setMessages(prevMessages => [...prevMessages, message]);
        });

        // Start connection
        newConnection.start()
            .then(() => {
                setConnection(newConnection);
            })
            .catch(err => console.error('SignalR Connection Error:', err));

        // Cleanup on unmount
        return () => {
            if (connection) {
                connection.stop();
            }
        };
    }, []);
    return (
        <div className="test-signalr">
            <h2>SignalR Test Page</h2>
            <div className="messages-container">
                <h3>Received Messages:</h3>
                {messages.map((message, index) => (
                    <div key={index} className="message">
                        {message}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TestSignalR;